<template>
    <div class="custom-psp">
        <h5 class="title body__medium">
            <span>
                {{ tokens.newDesign.paymentDetails }}
            </span>
        </h5>
        <div class="custom-info">
            <div class="custom-info-head">
                <span class="body__medium">{{ method.alias }}</span>
                <BaseButtonSmall @click.native="copyAddress(method.info || '')"
                    :button-text="tokens.newDesign.copy" :icon="'content_copy'" :button-style="'outlined-primary'" />
            </div>
            <p class="body__medium">{{ method.info }}</p>
        </div>
        <div class="custom-deposit">
            <h5 class="title body__medium">{{tokens.newDesign.otherDetails}}</h5>
            <BaseInput 
                    class="amount" 
                    v-model="amount" 
                    :type="'number'" 
                    :title="tokens.newDesign.amount" 
                    :placeholder="'0.00'"
                >
                <template #icon>
                    <p class="body__large">{{ currencySign('USD') }}</p>
                </template>
            </BaseInput>

            <div class="action">
                <p class="info body__extrasmall">*{{tokens.newDesign.depositText}}</p>
                <BaseButton
                    :button-text="tokens.newDesign.continue"
                    :button-style="'filled-tertiary'"
                    :disabled="!amount || disabledButton"
                    @click.native="makeDeposit"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseButtonSmall from "@/new-design/shared/ui/buttons/BaseButtonSmall.vue"
import { NOTIFICATION } from "@/store/mutations.type"
import {currencySign} from "@/common/helpers"
import BaseInput from "@/new-design/shared/ui/Inputs/BaseInput.vue"
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue"

export default {
    name: "CustomMethod",
    components: { BaseButtonSmall, BaseInput, BaseButton },
    props: {
        method: {
            type: Object,
            default: () => { }
        },
        disabledButton: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            amount: null,
        }
    },
    computed: {
        ...mapGetters(['conversions', 'user', 'pspList','tokens','staticBase']),
    },
    methods: {
        copyAddress(wallet) {
            navigator.clipboard.writeText(wallet)
                .then(() => {
                    this.$store.commit(NOTIFICATION, this.newDesign.addressCopied)
                })
                .catch(() => {
                })
        },
        makeDeposit() {
            this.$emit('update', {
                info: {
                    amount: this.amount,
                    currency: 'USD'
                }
            })
        },
        currencySign
    },
    watch: {
        'method': {
            handler() {
                this.amount = null;
            }
        }
    }
}
</script>

<style scoped>
.title {
    color: var(--System-OnSurface);
    padding: 16px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}

.custom-info {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 4px;
    background: var(--System-Surface1);

    .custom-info-head{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--System-Surface5);
        padding-bottom: 16px;

        span {
            overflow: hidden;
            color: var(--System-OnSurface);
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    p {
        color: var(--System-OnSurface);
        display: flex;
        gap: 8px;
        white-space: pre-line;
    }
}

.custom-deposit{
    display: flex;
    flex-direction: column;
    gap: 16px;

    h5{
        margin-top: 10px;
        margin-bottom: -10px;
    }
    
    .action{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
    }
}

@media (max-width: 468px) {
    .title {
        text-align: left;
    }
}
</style>
